import React, { useContext, useEffect, useState } from 'react';
import {
    Box,
    Button,
    Container,
    Typography,
} from "@mui/material";
import { useLocation, useNavigate } from 'react-router-dom';
import { apisPath, paths } from '../../../../utils/path';
import XlsIcon from "../../../Images/xls-icon.svg"
import { CommonContext } from '../../../../context/CommonContext';
import { downloadBlob, executeDownload } from '../../../../helpers/commonHelper';
import { authHttp } from '../../../../services/commonHttpService';


const StatewiseStatsTable = () => {
    const navigate = useNavigate();
    const location = useLocation();

    // Get data from location state
    const { type, stateWiseData } = location.state || {};
    const { setIsLoading, setSnackState } = useContext(CommonContext);

    const [stateWiseDataNew, setStateWiseDataNew] = useState([]);

    // Type configuration mapping
    const typeConfig = {
        tccc: {
            title: "TCCC State-Wise Statistics",
            columnHeader: "Total TCCC",
            dataKey: "total_mi",
            buttonType: "TCCC"
        },
        dccc: {
            title: "DCCC State-Wise Statistics",
            columnHeader: "Total DCCC",
            dataKey: "total_dccc",
            buttonType: "DCCC"
        },
        beneficiaries: {
            title: "Beneficiaries State-Wise Statistics",
            columnHeader: "Total Beneficiaries",
            dataKey: "total_patients"
        },
        chemo: {
            title: "Chemo Sessions State-Wise Statistics",
            columnHeader: "Total Chemo Sessions",
            dataKey: "total_chemo"
        }
    };

    const fetchStateWiseData = async () => {
        try {
            setIsLoading(true);

            const res = await authHttp.get(`${apisPath?.reports?.getNationalReportView}?facility_type=${type.toUpperCase()}`);
            if (res?.data?.status) {
                const states = res?.data?.data;
                setStateWiseDataNew(states);
            }
        } catch (err) {
            setSnackState({
                open: true,
                message: err?.response?.data?.message || "Failed to fetch state-wise data",
                severity: "error",
            });
        } finally {
            setIsLoading(false);
        }
    };



    const handleDownload = (facilityType) => {
        const fileName = `${facilityType}_Facility_Statewise_Count.xlsx`;
        executeDownload(apisPath?.reports?.downloadNationalReport, { facility_type: facilityType }, fileName, setIsLoading, setSnackState);
    };

    useEffect(() => {
        // Redirect to dashboard if type or data is missing/invalid
        if (!type || !typeConfig[type]) {
            navigate(`${paths?.user?.commonPoint}${paths?.user?.adminDashboard}`);
        }

        if (type === "tccc" || type === "dccc") {
            fetchStateWiseData();
        }
    }, [type, navigate]);

    // Get current configuration based on type
    const config = type && typeConfig[type] ? typeConfig[type] : null;

    // Don't render if no valid type or data
    if (!config || !stateWiseData) {
        return null;
    }

    return (
        <>
            <Box
                sx={{
                    width: "100%",
                    backgroundColor: "#FFFFFF",
                    borderBottom: "1px solid #E6E6E6", // light grey line
                    py: 2,
                }}
            >
                <Container>
                    {/* Title */}
                    <Typography variant="h6" fontWeight="600">
                        Day Care Cancer Center
                    </Typography>

                    {/* Subtitle */}
                    <Typography variant="body2" color="gray" sx={{ mt: 0.3 }}>
                        National Cancer Care Program - Comprehensive Overview
                    </Typography>
                </Container>
            </Box>

            <Container>
                <div className="d-flex align-items-center justify-content-between mt-3">
                    <Typography variant="h6" fontWeight={600}>
                        {config?.title}
                    </Typography>

                    <div className="btnSec">
                        <Button
                            variant="outlined"
                            className='dwnBtnAdmin'
                            onClick={() => handleDownload(config?.buttonType)}
                        >
                            <img src={XlsIcon} alt="XLS Icon" style={{ marginRight: '8px' }} />
                            Download Excel
                        </Button>

                    </div>
                </div>

                {/* Table Section */}
                <div className="shadow table-design my-3">
                    <div className="table-responsive mt-2">
                        <table className="table align-middle mb-0 custom-table">
                            <thead>
                                <tr>
                                    <th>S.No.</th>
                                    <th>States</th>
                                    <th>{config?.columnHeader}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {stateWiseDataNew && stateWiseDataNew.length > 0 ? (
                                    stateWiseDataNew.map((state, index) => (
                                        <tr key={state?.state_lgd || index}>
                                            <td>{index + 1}</td>
                                            <td>{state?.state_name || "N/A"}</td>
                                            {/* <td>{state?.[config?.dataKey] || "0"}</td> */}
                                            <td>{state?.total_count || "0"}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="3" className="text-center">
                                            No data available
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </Container>
        </>
    )
}

export default StatewiseStatsTable